import { Kevel } from './kevel.js?v=2.2';
import { SelectPromotionEvent } from './select-promotion-event.js';

const fdKevel = new Kevel();
fdKevel
  .load(
    [
      {
        divName: 'billboard-home',
        networkId: 11757,
        siteId: 1303014,
        zoneIds: [329729],
        adTypes: [11423, 123],
      },
    ],
    [`page=${window.location.pathname}`]
  )
  .onSuccess((ev) => {
    const data = ev.detail;
    let selectPromotionEvent = new SelectPromotionEvent();
    if (data.decisions['billboard-home'] != null) {
      const campaignContent = data.decisions['billboard-home'].contents[0];
      const firstBlock = document.querySelector('#billboard-home .billboard-home-card');

      if (campaignContent.data.ctTitle !== undefined) {
        firstBlock.querySelector('.billboard-home-card-title').innerHTML = campaignContent.data.ctTitle;
        firstBlock.querySelector('.billboard-home-card-title').style.fontWeight = 'bold';
      } else {
        firstBlock.querySelector('.billboard-home-card-title').remove();
        firstBlock.querySelector('.billboard-home-card-content').style.placeContent = 'flex-end';
      }

      firstBlock.dataset.bannerPromo = 'banner';
      firstBlock.dataset.bannerId = data.decisions['billboard-home'].flightId || null;
      firstBlock.dataset.bannerName = campaignContent.data.ctcampaignName || 'none';
      firstBlock.dataset.creativeSlot = campaignContent.data.ctcreativeSlot || 'none';
      firstBlock.dataset.itemId = campaignContent.data.ctid || 'none';
      firstBlock.dataset.bannerIndex = 1;
      firstBlock.dataset.bannerImg =
        `https://s.zkcdn.net/Advertisers/${campaignContent.data.ctDesktopImage}` ||
        `https://s.zkcdn.net/Advertisers/${campaignContent.data.ctMobileImage}`;

      firstBlock
        .querySelector('.picture')
        .getElementsByTagName(
          'img'
        )[0].src = `https://s.zkcdn.net/Advertisers/${campaignContent.data.ctDesktopImage}`;
      firstBlock
        .querySelector('.picture')
        .getElementsByTagName(
          'source'
        )[0].srcset = `https://s.zkcdn.net/Advertisers/${campaignContent.data.ctMobileImage}`;

      const link = firstBlock.querySelector('.billboard-home-card-link');
      const aElement = document.createElement('a');
      aElement.classList.add('billboard-home-link');
      aElement.dataset.bannerPromo = 'banner';
      aElement.dataset.bannerId = data.decisions['billboard-home'].flightId || null;
      aElement.dataset.bannerName = campaignContent.data.ctcampaignName || 'none';
      aElement.dataset.creativeSlot = campaignContent.data.ctcreativeSlot || 'none';
      aElement.dataset.itemId = campaignContent.data.ctid || 'none';
      aElement.dataset.bannerIndex = 1;
      aElement.dataset.bannerImg =
        `https://s.zkcdn.net/Advertisers/${campaignContent.data.ctDesktopImage}` ||
        `https://s.zkcdn.net/Advertisers/${campaignContent.data.ctMobileImage}`;
      aElement.href = data.decisions['billboard-home'].clickUrl;
      aElement.innerHTML = link.innerHTML;
      link.parentNode.replaceChild(aElement, link);

      if (campaignContent.data.ctBackgroundColor !== undefined) {
        firstBlock.style.backgroundColor = campaignContent.data.ctBackgroundColor;
      }

      if (campaignContent.data.ctTextColor !== undefined) {
        firstBlock.querySelector('.billboard-home-card-title').style.color = campaignContent.data.ctTextColor;
      }

      firstBlock.addEventListener('click', function (e) {
        selectPromotionEvent.setData('banner', 1, this);
      });
      firstBlock.style.removeProperty('background-color');
    } else {
      const firstBlock = document.querySelector('#billboard-home .billboard-home-card');
      firstBlock.classList.remove('billboard-home-card-placeholder');
      firstBlock.firstElementChild.classList.remove('hidden');
    }
  })
  .onError((ev) => {
    const firstBlock = document.querySelector('#billboard-home .billboard-home-card');
    firstBlock.firstElementChild.classList.remove('hidden');
    firstBlock.classList.remove('billboard-home-card-placeholder');
  })
  .onComplete(() => {
    const firstBlock = document.querySelector('#billboard-home .billboard-home-card');
    firstBlock.classList.remove('billboard-home-card-placeholder');
  });
